import styled from 'styled-components'

export const Ico = styled.i`
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: ${({ color }) => color};
  border-radius: 50%;
`

export const WrapItens = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 22px;

  li {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 16px;

    span {
      font-weight: lighter;
      font-size: var(--font-size-sm);
      color: var(--light-gray);
    }
  }
`
